/* eslint-disable no-restricted-syntax */
export const sortOrders = {
  TYPE: 'type',
  NEW_TO_OLD: 'newToOld',
  OLD_TO_NEW: 'oldToNew',
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
} as const

export type SortOrder = (typeof sortOrders)[keyof typeof sortOrders]

export const sortOrderMarketingTypes: Record<SortOrder, string> = {
  [sortOrders.TYPE]: 'type',
  [sortOrders.NEW_TO_OLD]: 'new to old',
  [sortOrders.OLD_TO_NEW]: 'old to new',
  [sortOrders.ASCENDING]: 'ascending name',
  [sortOrders.DESCENDING]: 'descending name',
}

export const sortOrderLabels: Record<SortOrder, string> = {
  [sortOrders.TYPE]: 'Type',
  [sortOrders.NEW_TO_OLD]: 'New to Old',
  [sortOrders.OLD_TO_NEW]: 'Old to New',
  [sortOrders.ASCENDING]: 'Ascending (A-Z)',
  [sortOrders.DESCENDING]: 'Descending (Z-A)',
}
